import { callGetExternalApi, callPostExternalApi } from '@ctn/axios-util';

import type { IUserAuth } from '@/interfaces/model/user.interface';
import { processError } from '@/utils/axiosErrors';
import axiosInstance, { noTokenInstance } from '@/utils/axiosInterceptor';

const baseURL = '/login';

type ILoginForm = {
	username: string;
	password: string;
};

type IParams = {
	code?: string;
	state?: string;
	username?: string;
};

type IAcceso = {
	token?: string;
	message?: string;
	errores?: string[];
};

const getBackendUrl = ({ code, state, username }: IParams) => ({
	POST_LOGIN: `${baseURL}`,
	GET_KEYCLOAK: `${baseURL}/autorizacion`,
	GET_ACCESO: `${baseURL}/acceso?code=${code}&state=${state}`,
	GET_LOGOUT: `${baseURL}/cierre?username=${username}`,
});

const postLogin = async (data: ILoginForm) =>
	callPostExternalApi<IUserAuth>({
		axiosInstance: noTokenInstance,
		withCredentials: true,
		url: getBackendUrl({}).POST_LOGIN,
		data,
	});
const getKeyCloakLogin = async () =>
	callGetExternalApi<string>({ axiosInstance: noTokenInstance, processError, url: getBackendUrl({}).GET_KEYCLOAK, });
const getAcceso = async (code: string, state: string) =>
	callGetExternalApi<IAcceso>({
		axiosInstance: noTokenInstance,
		withCredentials: true,
		url: getBackendUrl({ code, state }).GET_ACCESO,
	});
const getLogout = async (username: string) =>
	callGetExternalApi<string>({ axiosInstance, withCredentials: true, url: getBackendUrl({ username }).GET_LOGOUT });

export { postLogin, getKeyCloakLogin, getAcceso, getLogout };
